import { SidebarTrigger } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";
import { NotificationBell } from "./notification.bell";
import { ThemeModeToggle } from "./theme.mod.toggle";

const HeaderLayout = ({ className }: { className?: string }) => {
  return (
    <header className={cn(`flex items-center w-full justify-between`, className)}>
      <SidebarTrigger />

      <div className={cn("flex gap-4 mr-3")}>
        <ThemeModeToggle />
        <NotificationBell />
        {/* <Avatar>
          <AvatarImage
            src={user && user.gender === "MALE" ? `/avatar_male.png` : "/avatar_female.png"}
            alt="avatar"
            className={cn("w-10 h-10 rounded-full")}
          />
          <AvatarFallback>CN</AvatarFallback>
        </Avatar>
        <DropdownMenu open={isDropdownOpen} onOpenChange={setIsDropdownOpen} modal={false}>
          <DropdownMenuTrigger>
            <div className={cn("grid gap-1")}>
              <p
                className={cn("text-sm font-medium leading-none")}
              >{`${user.name} ${user.surname}`}</p>
              <p className={cn("text-sm text-muted-foreground")}>{user.email}</p>
            </div>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuLabel>Мой профиль</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => setIsPersonalAccountOpen(true)}>
              Настройки
            </DropdownMenuItem>

            <DropdownMenuItem onClick={logout}>
              <span className={cn("text-red-700 font-semibold dark:text-red-600")}>Выйти</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
        {user && (
          <PersonalAccount
            isPersonalAccountOpen={isPersonalAccountOpen}
            setIsPersonalAccountOpen={() => setIsPersonalAccountOpen(false)}
            user={user}
          />
        )} */}
      </div>
    </header>
  );
};

export default HeaderLayout;
